import { ArrowUpRight } from 'lucide-react';
import { PageHeader } from '../../components/office';

// The Verlo Guide, from the back office (Martin, 27 Oct: "would it be an idea to have it linked
// in the back office? Underneath The business"). The guide lives on the marketing site
// (verlohq.com/guide); this lists its two books, chapter by chapter, each opening there in a
// new tab. VITE_GUIDE_URL points it at another copy (the dev stack's, on :3002).

export const GUIDE_URL = (import.meta.env.VITE_GUIDE_URL || 'https://verlohq.com/guide').replace(/\/$/, '');

export const BOOKS = [
  {
    key: 'back-office',
    name: 'Back Office',
    who: 'For whoever runs the place',
    chapters: [
      ['Start here', 'What Verlo is, signing in, finding your way, and who sees what', 'start-here'],
      ['Your business', 'Settings, the trading day, the kitchen, the cash, and what’s left before you open', 'your-business'],
      ['Your menu', 'Dishes, prices and sizes, costs, allergens, choices and offers', 'your-menu'],
      ['Your team', 'Staff, PINs, accounts, the rota and timesheets', 'your-team'],
      ['Your stock', 'Suppliers, par, ordering and sending, deliveries, counts and waste', 'your-stock'],
      ['The morning after', 'Today, yesterday in full, cash-ups, discounts and refunds', 'the-morning-after'],
      ['Where the money goes', 'Profit and loss, the budget, margins, labour and what sells', 'where-the-money-goes'],
      ['Your own reports', 'Compare anything, build reports, and have them emailed', 'your-own-reports'],
      ['Keeping it safe', 'Accounts, two-factor, leavers, and the audit log', 'keeping-it-safe'],
      ['Keeping your old till', 'The back office on its own: bringing in your till’s sales', 'keeping-your-old-till'],
    ],
  },
  {
    key: 'front-of-house',
    name: 'Front of House',
    who: 'For anyone working a service',
    chapters: [
      ['Before the doors open', 'Signing in, the float, the floor, and tonight’s bookings', 'before-the-doors-open'],
      ['Taking an order', 'Seating a table, allergies, choices, and sending it', 'taking-an-order'],
      ['The kitchen and the bar', 'Tickets, stations, and sending more to a table', 'the-kitchen-and-the-bar'],
      ['When things change', 'Taking things back, comps, offers, and more time', 'when-things-change'],
      ['The bill', 'Card and cash, tips, splitting it, receipts and refunds', 'the-bill'],
      ['Closing up', 'Paid-outs, counting the drawer, and the Z read', 'closing-up'],
      ['When the internet goes down', 'How the till keeps trading, and what waits', 'when-the-internet-goes-down'],
    ],
  },
];

export default function GuidePage() {
  return (
    <div className="space-y-5" data-testid="guide-page">
      <PageHeader title="The Verlo Guide" purpose="How to use Verlo, in two books: one for whoever runs the place, one for anyone working a service. Each chapter opens in a new tab."
        actions={<a href={GUIDE_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-md border border-hairline-strong bg-white px-3 py-2 text-[13.5px] font-semibold text-ink hover:bg-hover-tint" data-testid="guide-open">Open the guide<ArrowUpRight size={15} /></a>} />
      <div className="grid gap-4 lg:grid-cols-2">
        {BOOKS.map((b) => (
          <section key={b.key} className="rounded-lg border border-hairline bg-white" data-testid={`guide-book-${b.key}`}>
            <div className="border-b border-hairline px-5 py-4">
              <h2 className="font-heading text-[18px] font-extrabold text-ink">{b.name}</h2>
              <p className="text-[13px] text-ink-soft">{b.who}</p>
            </div>
            <ol className="divide-y divide-hairline">
              {b.chapters.map(([title, about, slug], i) => (
                <li key={slug}>
                  <a href={`${GUIDE_URL}/${b.key}/${slug}`} target="_blank" rel="noreferrer"
                    className="grid grid-cols-[28px_minmax(0,1fr)_auto] items-start gap-3 px-5 py-3 hover:bg-hover-tint" data-testid={`guide-chapter-${b.key}-${slug}`}>
                    <span className="font-mono text-[13px] tabular-nums text-ink-faint">{b.key === 'back-office' && i === 0 ? '·' : b.key === 'back-office' ? i : i + 1}</span>
                    <span className="min-w-0">
                      <span className="block text-[14.5px] font-semibold text-ink">{title}</span>
                      <span className="block text-[12.5px] text-ink-soft">{about}</span>
                    </span>
                    <ArrowUpRight size={15} className="mt-1 text-ink-faint" />
                  </a>
                </li>
              ))}
            </ol>
          </section>
        ))}
      </div>
    </div>
  );
}
